import React from 'react';
import { motion } from 'framer-motion';
import { Book, HeartPulse, Skull, Activity, BriefcaseMedical } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <Book className="text-brand" size={28} data-id="element-158" />,
    title: 'Guía Principal',
    desc: 'El Protocolo Semáforo completo paso a paso (PDF).'
  }, {
    icon: <HeartPulse className="text-brand" size={28} data-id="element-159" />,
    title: 'Maniobras de Rescate',
    desc: 'Instrucciones para asfixia (Heimlich felino) y heridas graves.'
  }, {
    icon: <Skull className="text-brand" size={28} data-id="element-160" />,
    title: 'Mapa de Tóxicos',
    desc: 'Lista de plantas y productos comunes en hogares argentinos que son veneno puro.'
  }, {
    icon: <Activity className="text-brand" size={28} data-id="element-161" />,
    title: 'Ficha de Signos Vitales',
    desc: 'Cómo saber si su corazón y pulmones están bien en casa.'
  }];
  return <section className="py-12 px-4 bg-neutral-950" data-id="element-162">
      <div className="container mx-auto max-w-4xl" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-164">
          <h2 className="text-5xl md:text-6xl font-display text-white mb-4" data-id="element-165">
            ¿Qué incluye la guía?
          </h2>
          <p className="text-xl text-neutral-400" data-id="element-166">
            Todo lo que necesitás para actuar rápido y seguro.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-167">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-neutral-900 border border-neutral-800 p-6 rounded-2xl flex items-start gap-4" data-id="element-168">
              <div className="bg-brand/10 p-3 rounded-xl shrink-0" data-id="element-169">
                {item.icon}
              </div>
              <div data-id="element-170">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-171">
                  {item.title}
                </h3>
                <p className="text-neutral-400" data-id="element-172">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-brand/20 to-brand-dark/20 border-2 border-brand p-8 rounded-2xl flex flex-col md:flex-row items-center gap-6 relative overflow-hidden" data-id="element-173">
          <div className="absolute -right-10 -top-10 text-brand/10" data-id="element-174">
            <BriefcaseMedical size={150} data-id="element-175" />
          </div>
          <div className="bg-brand text-white p-4 rounded-2xl shrink-0 relative z-10" data-id="element-176">
            <BriefcaseMedical size={40} data-id="element-177" />
          </div>
          <div className="relative z-10 text-center md:text-left" data-id="element-178">
            <div className="inline-block bg-brand text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-2" data-id="element-179">
              Bono Exclusivo
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-180">
              Checklist del Botiquín de Emergencia
            </h3>
            <p className="text-neutral-300 text-lg" data-id="element-181">
              La lista exacta de lo que tenés que comprar en cualquier farmacia
              de barrio para estar preparado hoy mismo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}